import { ElementRef, ElementType, ForwardedRef, forwardRef } from "react"
import { cx } from "@emotion/css"
import type {
  PolymorphicForwardRefExoticComponent,
  PolymorphicPropsWithoutRef,
  PolymorphicPropsWithRef,
} from "../utils/react-polymorphic-types"

import styles from "./styles"

const ButtonDefaultElement = "button"

type IconButtonOwnProps = {
  color?: "default" | "primary" | "destructive"
  variant?: "default" | "square"
}

export type IconButtonProps<
  T extends ElementType = typeof ButtonDefaultElement,
> = PolymorphicPropsWithRef<IconButtonOwnProps, T>

const IconButton: PolymorphicForwardRefExoticComponent<
  IconButtonOwnProps,
  typeof ButtonDefaultElement
> = forwardRef(function IconButton<
  T extends ElementType = typeof ButtonDefaultElement,
>(
  props: PolymorphicPropsWithoutRef<IconButtonOwnProps, T>,
  ref: ForwardedRef<ElementRef<T>>,
) {
  const {
    as,
    //
    color = "default",
    variant = "default",
    children,
    type = "button",
    className,
    ...rest
  } = props

  const cn = cx(styles.base, styles.iconButton, className)

  const Element: ElementType = as || ButtonDefaultElement

  return (
    <Element
      ref={ref}
      type={type}
      className={cn}
      data-color={color}
      data-variant={variant}
      {...rest}
    >
      {children}
      {/* <span className={"icon"}>{}</span> */}
    </Element>
  )
})

export default IconButton
